import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export async function apiPost(path, body) {
  const p = path.startsWith("/") ? path : `/${path}`;
  const res = await axios.post(`${API}${p}`, body);
  return res.data;
}

export async function apiGet(path) {
  const p = path.startsWith("/") ? path : `/${path}`;
  const res = await axios.get(`${API}${p}`);
  return res.data;
}

export const storage = {
  get(key) {
    try {
      return window.localStorage.getItem(key);
    } catch {
      return null;
    }
  },
  set(key, value) {
    try {
      window.localStorage.setItem(key, value);
    } catch {
      /* noop */
    }
  },
  remove(key) {
    try {
      window.localStorage.removeItem(key);
    } catch {
      /* noop */
    }
  },
};
